import { render, staticRenderFns } from "./groupCurrentBooksView.vue?vue&type=template&id=62e97cf4&scoped=true&"
import script from "./groupCurrentBooksView.vue?vue&type=script&lang=js&"
export * from "./groupCurrentBooksView.vue?vue&type=script&lang=js&"
import style0 from "./groupCurrentBooksView.vue?vue&type=style&index=0&id=62e97cf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e97cf4",
  null
  
)

export default component.exports